import { z } from 'zod';

/**
 * Admin-panel access roles (the `admin_roles` table, keyed by email):
 *   admin — full admin access (can grant/revoke access)
 *   staff — dashboard access only
 */
export const AdminAccessRoleSchema = z.enum(['admin', 'staff']);
export type AdminAccessRole = z.infer<typeof AdminAccessRoleSchema>;

/** Grant/change request body for POST /api/admin/roles. */
export const AdminRoleGrantSchema = z.object({
  email: z.string().email(),
  role: AdminAccessRoleSchema,
});
export type AdminRoleGrantInput = z.infer<typeof AdminRoleGrantSchema>;

/** One row of the access list (GET /api/admin/roles). */
export interface AdminRoleRow {
  email: string;
  role: AdminAccessRole;
}
